import { useContext } from "react";

import { OakStreamClientContext } from "./context";

export function useOakStreamClient() {
  const client = useContext(OakStreamClientContext);

  if (client === null) {
    throw new Error("useOakStream must be used within OakStreamClientProvider.");
  }

  return client;
}
